import { motion } from 'framer-motion';

interface Streak {
  merchant: string;
  days: number;
}

interface TopStreaksBoxProps {
  streak: Streak;
}

export const TopStreaksBox = ({ streak }: TopStreaksBoxProps) => {
  return (
    <div className="bg-white rounded-xl p-4 border-2 border-[#221A51] shadow-[4px_4px_0px_0px_#221A51]">
      <div className="text-[#221A51]/60 text-sm mb-3">Longest Streak</div>
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.3 }}
        className="flex items-center justify-between"
      >
        <div className="text-base text-[#221A51] min-w-0 flex-1 mr-4">
          <span className="font-bold truncate whitespace-nowrap block">{streak.merchant}</span>
        </div>
        <div className="w-14 h-14 bg-[#1A1425] rounded-lg flex items-center justify-center">
          <div className="text-center">
            <div className="text-[#9BFFA9] font-mono text-xl font-bold">
              {streak.days}
            </div>
            <div className="text-white/60 text-[10px]">days</div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};
